import React, { useState, useEffect } from 'react';
import icon from '../images/icon-n.png';
import ricon from '../images/icon-n-r.png';
import instructions from '../images/instruct-n.png';
import Rinstructions from '../images/r-instruct-n.png';

const handleQuitInstructions = () => {
  const instructionsDiv = document.getElementById('instructions-div');
  if (instructionsDiv) instructionsDiv.style.display = 'none';
};

const SlideComponent = ({ actual, first, second, onSaveAnswers }) => {
  const [title, setTitle] = useState(null);

  const savedAnswer = JSON.parse(localStorage.getItem('currentAnswer') || '{}');

  const selectedButtonGroup0 = savedAnswer.selectedButtonGroup0; // tono (ej. rubí)
  const selectedButtonGroup1 = savedAnswer.selectedButtonGroup1; // intensidad color (ej. medio)
  const selectedButtonGroup2 = savedAnswer.selectedButtonGroup2; // intensidad nariz
  const selectedButtonGroup3 = savedAnswer.selectedButtonGroup3; // primarios (array)
  const selectedButtonGroup4 = savedAnswer.selectedButtonGroup4; // secundarios (array)
  const selectedButtonGroup5 = savedAnswer.selectedButtonGroup5; // terciarios (array)
  const selectedButtonGroup6 = savedAnswer.selectedButtonGroup6; // {a,b,c,d,e,f}
  const selectedButtonGroup7 = savedAnswer.selectedButtonGroup7; // jerarquía
  const selectedButtonGroup8 = savedAnswer.selectedButtonGroup8; // precio 1..6

  useEffect(() => {
    const savedTest = JSON.parse(localStorage.getItem('currentTest') || '{}');
    setTitle(savedTest?.title ?? null);
  }, []);

  // Helpers seguros
  const safeJoin = (v) => (Array.isArray(v) ? v.filter(Boolean).join(', ') : '');
  const idx = (v) => (typeof v === 'number' ? v : null);

  // Palabras (5 niveles)
  const dulzorWords = ['Seco', 'Casi seco', 'Semiseco', 'Semidulce', 'Muy dulce'];
  const acidezWords = ['Baja', 'Media(-)', 'Media', 'Media(+)', 'Alta'];
  const taninoWords = ['Bajo', 'Medio(-)', 'Medio', 'Medio(+)', 'Alto'];
  const cuerpoWords = ['Poco', 'Medio(-)', 'Medio', 'Medio(+)', 'Alto'];
  const finalWords  = ['Corto', 'Medio(-)', 'Medio', 'Medio(+)', 'Largo'];

  // Si alcohol sigue siendo 3:
  const alcoholWords = ['Bajo', 'Medio', 'Alto'];

  const tasteA = idx(selectedButtonGroup6?.a) != null ? dulzorWords[selectedButtonGroup6.a] : '';
  const tasteB = idx(selectedButtonGroup6?.b) != null ? acidezWords[selectedButtonGroup6.b] : '';
  const tasteC = idx(selectedButtonGroup6?.c) != null ? taninoWords[selectedButtonGroup6.c] : '';
  const tasteD = idx(selectedButtonGroup6?.d) != null ? cuerpoWords[selectedButtonGroup6.d] : '';
  const tasteE = idx(selectedButtonGroup6?.e) != null ? finalWords[selectedButtonGroup6.e] : '';
  const tasteF = idx(selectedButtonGroup6?.f) != null ? alcoholWords[selectedButtonGroup6.f] : '';

  // Precio (categoría 1..6)
  const priceLabelById = {
    1: '0 - 15€',
    2: '15€ - 25€',
    3: '25€ - 35€',
    4: '35€ - 50€',
    5: '50€ - 80€',
    6: '80€ - 150€',
  };
  const priceLabel = priceLabelById[selectedButtonGroup8] ?? '';

  // Jerarquía (nombres nuevos)
  const variedad = selectedButtonGroup7?.selectorVariedad ?? '';
  const pais = selectedButtonGroup7?.selectorPais ?? '';
  const region = selectedButtonGroup7?.selectorRegion ?? '';
  const bodega = selectedButtonGroup7?.selectorBodega ?? '';
  const marca = selectedButtonGroup7?.selectorMarca ?? '';

  const anadaRaw = selectedButtonGroup7?.selectorAnada;
  const anada =
    anadaRaw === 0 || anadaRaw === '0'
      ? 'Sin añada'
      : (anadaRaw ?? '');

  return (
    <div className="slide-container">
      <div className="overlay" id="instructions-div">
        <img
          src={instructions}
          alt="Imagen"
          className="centered-image dekstop"
          onClick={handleQuitInstructions}
        />
        <img
          src={Rinstructions}
          alt="Imagen"
          className="centered-image mobile"
          onClick={handleQuitInstructions}
        />
      </div>


      <div className="actual-wine">{title}</div>

      <h2>Respuesta</h2>

      <div className="cont-sub-section">
        <div className="text-note col-sub-section-2">
          <div className="section-title">Nota de cata</div>

          <p>
            Este vino tiene un color{' '}
            <span>{selectedButtonGroup1} {selectedButtonGroup0}</span>.
            {' '}En nariz tiene una <span>intensidad {selectedButtonGroup2}</span> con aromas primarios{' '}
            <span>({safeJoin(selectedButtonGroup3)})</span>, aromas secundarios{' '}
            <span>({safeJoin(selectedButtonGroup4)})</span> y aromas terciarios{' '}
            <span>({safeJoin(selectedButtonGroup5)})</span>.
            {' '}Es un vino <span>{tasteA}</span>, con acidez <span>{tasteB}</span>, tanino{' '}
            <span>{tasteC}</span>, cuerpo <span>{tasteD}</span> y final <span>{tasteE}</span>
            {tasteF ? <> (alcohol: <span>{tasteF}</span>)</> : null}.
          </p>

          {/* Quitado el gráfico */}
        </div>

        <div className="col-sub-section-2">
          <div className="note-select-container">
            <h4>Variedad</h4>
            <select disabled>
              <option>{variedad}</option>
            </select>
          </div>

          <div className="note-select-container">
            <h4>País</h4>
            <select disabled>
              <option>{pais}</option>
            </select>
          </div>

          <div className="note-select-container">
            <h4>Región</h4>
            <select disabled>
              <option>{region}</option>
            </select>
          </div>

          <div className="note-select-container">
            <h4>Bodega</h4>
            <select disabled>
              <option>{bodega}</option>
            </select>
          </div>

          <div className="note-select-container">
            <h4>Marca</h4>
            <select disabled>
              <option>{marca}</option>
            </select>
          </div>

          <div className="note-select-container">
            <h4>Añada</h4>
            <select disabled>
              <option>{anada}</option>
            </select>
          </div>

          <div className="note-select-container">
            <h4>Precio</h4>
            <div className="input-price-container">
                <p>Precio: {selectedButtonGroup8 ?? '-'}</p>
            </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default SlideComponent;